import ProfileCard from 'Components/profilePage/ProfileCard'
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom'
import plusIcon from "assets/Images/icons/plusIcon.png"
import defaultCardImg from "assets/Images/icons/defaultCardImg.png"
import BookingCard from "Components/profilePage/BookingCard"
import NotLoggedIn from "Components/notLoggedIn";

// MY LISTING PAGE

const MyListings = (props) => {
    //=============== user ====================
    let user = props.current_user; 
    // =================check if user is logged in ======================
    if (user && user?.isAuth) {
        if (user.is_captain === true) {
            //===================== If logged in user is captain, because this page is only for captain to see their created listings ======================
            return (
                <div className="captain-listing-page">
                    <div className="container header-spacer">
                        <div className="row">
                            <div className="col-md-3">
                                <ProfileCard
                                    data={{
                                        profileImg: user?.profileImg || '.',
                                        userName: user.name + " " + user.surname,
                                        subInfo: '38, Greece',
                                        mode: true,
                                        profileCard: true,
                                        viewMode: true,
                                        heading2: "All Listing Boats",
                                        heading3: "All Reviews",
                                        // heading4: "Messaging",
                                    }} />
                            </div>
                            <div className="col-md-9">
                                <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <h4 className="text-gr mb-md-4 mb-3">All Listing  ( <span className="text-sec">3</span> )</h4>
                                    <Link to="/AddBoat" className="mb-md-4 mb-3"><h4 className="text-sec all-listing-heading"><img src={plusIcon} alt="" /> &nbsp; Add New Boat</h4></Link>
                                </div>
                                <div className="pb-3 px-lg-1 px-3">
                                    {[0, 1, 2].map((v, i) => {
                                        return (
                                            <BookingCard
                                                key={i}
                                                myListing={true}
                                                data={{
                                                    mode: user?.is_captain,
                                                    img: defaultCardImg,
                                                    mainTitle: "Booking Information",
                                                    title: "Motorboat Azimut 62",
                                                    location: "Crete.Greece",
                                                    subtitle: "Starting Price",
                                                    guests: 'Up to 10',
                                                    boatType: "Yacht",
                                                    bookingType: 'Intra Day | Over Night',
                                                    price: "1260",
                                                    days: 'Day',
                                                    reviewText: "The trip was awesome! I could bring over my friends and got intraday booking so easily. The captain was so friendly. Thank you"
                                                }}
                                            />
                                        )
                                    })}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            //================= If not captain ================
            return (
                <>
                    <div className="container py-5 mt-5">
                        <div className="row py-5 mt-5">
                            <div className="col-12 text-center">
                                <h2>
                                    This Page is only for captain
                                </h2>
                            </div>
                        </div>
                    </div>

                </>
            )
        }
    } else {
        // if not logged in
        return (
            <NotLoggedIn />
        )
    }
}

//  REDUX CONFIGs
const mapStateToProps = (store) => ({
    current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(MyListings));
